import axios from 'axios';
import config from  '../../config';
import {USER_LOGOUT,UPDATE_CUSTOM_USER_DATA} from "actions/actionTypes";
import _ from "lodash";
  export function dispatchAction(payload, actionName) {
    return (dispatch, getState) => {
          dispatch({
            type: actionName,
            payload: payload
        })
    }
}

export function getCurrentStoreState() {
    return (dispatch, getState) => {
        return getState()
    }
}
export function makeRequest(data, methodData) {
     return (dispatch, getState) => {
        var requestPromise;
         let token = getState().userReducer.token;
         methodData['appData'] = getState().appData;
        methodData['getState'] = getState;
         var customHeaderData = _.get(methodData, 'customHeaderData',{})

        customHeaderData['request-source'] = 'dashboard';
        customHeaderData['client-application-version'] = config.applicationVersion;
        const {pathname = ''} = window.location;

        if (pathname.includes( '/client/')) {
          customHeaderData['request-source'] = 'shopify';
        }

         var baseURL =   methodData.overrideServerBaseURL ?  methodData.overrideServerBaseURL : config.getEnvironment().serverBaseURL
          if (_.isUndefined(methodData.type)){
                requestPromise =   axios.get(methodData['endpoint'], {
                params: data,
                baseURL: baseURL,
                headers: {'x-access-token': token,...customHeaderData}
            });
        } else if (methodData.type == 'post') {
            requestPromise = axios.post(methodData['endpoint'], data, {
                baseURL: baseURL,
                headers: {'x-access-token': token,...customHeaderData}
            })
        } else if (methodData.type == 'patch') {
            requestPromise = axios.patch(methodData['endpoint'], data, {
                baseURL: baseURL,
                headers: {'x-access-token': token,...customHeaderData}
            });
        }else if (methodData.type == 'delete') {
            requestPromise =  axios.delete(methodData['endpoint'],  {
                params: data,
                baseURL: baseURL,
                headers: {'x-access-token': token,...customHeaderData}
            })
        }
        return requestPromise.then(response => {
             // if (typeof response.data == 'string' && response.data.includes('<!DOCTYPE html>')) {
            //     throw  {'clientMessage': 'errorSomethingWrong'};
            // }

            if (_.isUndefined(methodData['not_display_success_message'])) {
                 _displayMessage(methodData);
            }

            if (!_.isUndefined(methodData['success_event'])) {
                var payload = {
                    ...response.data
                };
                 if (!_.isUndefined(methodData['success_event_data'])) {
                    _.assign(payload, methodData['success_event_data']);
                }
                dispatch({
                    type: methodData['success_event'],
                    payload: payload
                })
            }
            return response;
        })
            .catch(error => {
                 return handleError({error,methodData,dispatch})
            })
    }
}





export function handleError(params) {
    console.log('in handle error', params.error);
    return  new Promise ((resolve, reject) => {
        if (_.isUndefined(params.error.response)) {
            if ( params.error.message == 'Network Error') {
                _displayMessage({  ...params.methodData, messageType: 'warning', messageCode: 'errorConnection'});
            } else{ /* this is javascript error on client side */
                console.warn('error message', params.error.message);
            }
            reject(params.error);
        } else if(config.apiErrorCodeMap[getErrorCode(params.error)] == 'AccessTokenNotValid'  ) {
            console.log('log out and redirect to log in' );
            if (_.isUndefined(params.methodData['not_display_error_message'])) {
                _displayMessage({
                    ...params.methodData,
                    messageType: 'warning',
                    messageCode: getErrorMessage(params.error, params.defaultMessage)
                });
            }
            params.dispatch({
                type: USER_LOGOUT
            })

            reject(params.error);
        }else if(config.apiErrorCodeMap[getErrorCode(params.error)] == 'ClientApplicationVersionMustBeUpdated'  ) {
            console.log('ClientApplicationVersionMustBeUpdated',  );
            if (_.get(window, 'top.location.reload')){
                window.top.location.reload()
            }
            // _displayMessage({
            //     ...params.methodData,
            //     messageType: 'warning',
            //     messageCode:  'Updating application version'
            // });
            reject('');
        } else{
            if (_.isUndefined(params.methodData['not_display_error_message'])) {
                _displayMessage({
                    ...params.methodData,
                    messageType: 'warning',
                    messageCode: getErrorMessage(params.error, params.defaultMessage)
                });
            }
            reject(params.error);
        }
    });

}
export function getErrorMessage(err, defaultMessage = false) {
    if (err.response) {
        return err.response.data.message;
    } else if (err.clientMessage) {
        return err.clientMessage;
    } else {
        return defaultMessage ? defaultMessage : 'errorSomethingWrong';
    }
};
export function getErrorCode(err) {
    if (err.response) {
        return err.response.data.errorCode;
    } else {
        return '';
    }
};


export function fetchRecord(params, methodData) {
    return dispatch => {
        if (_.isUndefined(methodData['endpoint'])) {
            methodData['endpoint'] = '/' + methodData['type'] + '/' + encodeURIComponent(methodData.id);
        }
        return axios.get(methodData['endpoint'], {
            params: params
        })
            .then(response => {
                if (_.isUndefined(methodData['success_event'])) {
                    methodData['success_event'] = 'FETCH_' + methodData['type'].substring(0, methodData['type'].length - 1).toUpperCase();
                }
                var payload = {
                    'data': response.data
                };
                if (!_.isUndefined(methodData['success_event_data'])) {
                    _.assign(payload, methodData['success_event_data']);
                }
                console.log('payload fetch record', payload);

                dispatch({
                    type: methodData['success_event'],
                    payload: payload
                })
                return response;
            })
        // .catch(error => {
        //     console.log('Error', error.message);
        //  return Promise.reject(error);
        // })
    }
}

export function addRecord(data, methodData) {
    return (dispatch, getState) => {
        if (_.isUndefined(methodData['endpoint'])) {
            methodData['endpoint'] = '/' + methodData['type'];
        }
        methodData['appData'] = getState().appData;
        return axios.post(methodData['endpoint'], data)
            .then(response => {
                console.log('in response axios', response);
                // if (typeof response.data == 'String' && response.data.indexOf('<!DOCTYPE html>') == 0) {
                //     throw  {'clientMessage': 'errorSomethingWrong'};
                // }
                if (_.isUndefined(methodData['success_event'])) {
                    methodData['success_event'] = 'ADD_' + methodData['type'].substring(0, methodData['type'].length - 1).toUpperCase();
                }
                methodData.messageCode = 'recordAdded';
                thenDisplayMessage(methodData);
                var payload = {
                    'data': response.data
                };
                if (!_.isUndefined(methodData['success_event_data'])) {
                    _.assign(payload, methodData['success_event_data']);
                }
                dispatch({
                    type: methodData['success_event'],
                    payload: payload
                })
                return response;

            })
            .catch(error => {
                catchDisplayMessage(methodData, error);
                return Promise.reject(error);
            })
    }
}
export function updateRecord(data, methodData) {
    return (dispatch, getState) => {
        if (_.isUndefined(methodData['endpoint'])) {
            methodData['endpoint'] = '/' + methodData['type'] + '/' + encodeURIComponent(methodData.id);
        }
        methodData['appData'] = getState().appData;
        return axios.patch(methodData['endpoint'], data)
            .then(response => {
                if (_.isUndefined(methodData['success_event'])) {
                    methodData['success_event'] = 'UPDATE_' + methodData['type'].substring(0, methodData['type'].length - 1).toUpperCase();
                }
                if (_.isUndefined(methodData['messageData'])) { /* 'products' change to 'Product')*/
                    methodData['messageData'] = {'#1#': methodData['type'].charAt(0).toUpperCase() + methodData['type'].substring(0, methodData['type'].length - 1).slice(1)};
                }
                methodData.messageCode = 'recordUpdated';
                thenDisplayMessage(methodData);
                var payload = {
                    'data': response.data
                };
                if (!_.isUndefined(methodData['success_event_data'])) {
                    _.assign(payload, methodData['success_event_data']);
                }
                dispatch({
                    type: methodData['success_event'],
                    payload: payload
                })
                return response;

            })
            .catch(error => {
                catchDisplayMessage(methodData, error);
                return Promise.reject(error);
            })
    }
}

export function deleteRecord(methodData) {
    return (dispatch, getState) => {
        if (_.isUndefined(methodData['endpoint'])) {
            methodData['endpoint'] = '/' + methodData['type'] + '/' + encodeURIComponent(methodData.id);
        }
        methodData['appData'] = getState().appData;
        return axios.delete(methodData['endpoint'], {})
            .then(response => {
                thenDisplayMessage(methodData);
                if (_.isUndefined(methodData['success_event'])) {
                    methodData['success_event'] = 'DELETE_' + methodData['type'].substring(0, methodData['type'].length - 1).toUpperCase();
                }
                var payload = {
                    'data': {'_id': methodData['id']}
                };
                if (!_.isUndefined(methodData['success_event_data'])) {
                    _.assign(payload, methodData['success_event_data']);
                }
                dispatch({
                    type: methodData['success_event'],
                    payload: payload
                })
                return response;
            })
            .catch(error => {

                catchDisplayMessage(methodData, error);
                return Promise.reject(error);

            })
    }
}
export function displayMessage(params) {

     return (dispatch, getState) => {
         params['appData'] = getState().appData;
        params['getState'] = getState;
         _displayMessage(params);
    }
}
export function _displayMessage(params) {
      var message = '';
    if (!_.isUndefined(config.clientMessages[params.messageCode])) {
        message = config.clientMessages[params.messageCode]
        if (!_.isUndefined(params['messageData'])) {
            var re = new RegExp(Object.keys(params['messageData']).join("|"), "gi");
            message = message.replace(re, function (matched) {
                return params['messageData'][matched];
            });
        }
    } else if(!_.isUndefined(params.messageCode)) {
        /* from server or other messages */
        message = params.messageCode;
    }
    if(config.getEnvironmentName() == 'production') {

    }
     var notification = params.getState().appData.notification;
//   console.log('notification', notification  );
     if (notification && message!== '') {
        notification.addNotification({
            message: message,
            level: params['messageType'] || 'success',
            autoDismiss: params['autoDismiss'] ||  15,
            position:params['messagePosition'] ||   'br'
        });
    }

}
function thenDisplayMessage(params) {

    if (_.isUndefined(params['display_message'])) {
        var message;
        if (!_.isUndefined(params['messageData'])) {
            var re = new RegExp(Object.keys(params['messageData']).join("|"), "gi");
            message = config.clientMessages[params.messageCode].replace(re, function (matched) {
                return params['messageData'][matched];
            });
        } else {
            message = config.clientMessages[params.messageCode]
        }
        params.appData.notification.addNotification({
            message: message,
            level: params['messageType'] || 'success',
            autoDismiss: params['autoDismiss'] ||  15,
            position:params['messagePosition'] ||   'br'
        });
    }
}

function catchDisplayMessage(methodData, error) {
    console.log('in catch display message');
    var message;
    if (_.isUndefined(methodData['display_message'])) {
        if (!_.isUndefined(error.response) && !_.isUndefined(error.response.data) && !_.isUndefined(error.response.data.message)) { /* message from API */
            message = error.response.data.message;
        } else if (_.isUndefined(error['clientMessage'])) { /* message from webapp*/
            if (!_.isUndefined(methodData['messageData'])) { /* display client message */
                var re = new RegExp(Object.keys(methodData['messageData']).join("|"), "gi");
                message = config.clientMessages[error.response.data.message].replace(re, function (matched) {
                    return methodData['messageData'][matched];
                });
            } else {
                message = config.clientMessages[error.response.data.message];
            }
        }
        methodData.appData.notification.addNotification({
            message: message,
            level: 'error',
            autoDismiss: params['autoDismiss'] ||  20,
            position:params['messagePosition'] ||   'br'
        });
    }
    if (_.isUndefined(error.message)) { /* some other error, should not be displayed in process.process.env.NODE_ENV = 'production';*/
        console.log('Error', error.message, error.stack);
    }
}
export function updateAppData(data) {
    return dispatch => {
        dispatch({
            type: 'UPDATE_APP_DATA',
            payload: data
        })
    }
}



export function reorderImages(data, methodData) {
    return (dispatch, getState) => {
        methodData['appData'] = getState().appData;
         return axios.patch('/products/' + encodeURIComponent(methodData.productID) + '/images/reorder', data,
            {
                baseURL: config.getEnvironment().serverBaseURL,
                headers: {'x-access-token': getState().userReducer.token}
            })
            .then(response => {
                var payload = {'data': response.data};
                if (!_.isUndefined(methodData['success_event_data'])) {
                    _.assign(payload, methodData['success_event_data']);
                }

                dispatch({
                    type: UPDATE_ADMIN_PRODUCT_IMAGES,
                    payload: payload
                })
                methodData['messageCode'] = 'productImageOrderUpdated';
                thenDisplayMessage(methodData);
                return response;
            })
            .catch(error => {
                catchDisplayMessage(methodData, error);
                return Promise.reject(error);

            })
    }
}





